import {useAsset} from "../../AssetHelper";
import {useContext} from "react";
import {Timeout} from "../displayContainer";
import {t} from "../../i18n";
import './Blank.css';
import DisplayParams from "../DisplayParams";
import {DisplayConfig} from "../Config";
import MiniTimeout, {MiniTimeoutType} from "../layouts/MiniTimeout";
import EventLogo from "../components/EventLogo";

export default function Blank({ config }: {
    config: DisplayConfig
}) {
    const displayParams = useContext(DisplayParams);
    let assetPath = `img/bg/decode-bg-lockup${displayParams.alternatePresentingSponsor ? '-' + displayParams.alternatePresentingSponsor : ''}.svg`;
    if(config.type == 'cmpBar' && displayParams.isFirstChampionship && displayParams.divisionNumber) {
        assetPath = `img/bg/bg_bar_division_lockup.svg`;
    } else if(config.type == 'cmpBar') {
        assetPath = `img/bg/bg_bar_lockup.svg`;
    } else if(displayParams.isFirstChampionship && displayParams.divisionNumber) {
        assetPath = `img/bg/bg_cmp_division_lockup.svg`;
    } else if(displayParams.isFirstChampionship) {
        assetPath = `img/bg/bg_cmp_lockup.svg`;
    }
    const backgroundPath = useAsset(assetPath);
    const timeout = useContext(Timeout);

    return <>
        <div className={"h-100 w-100 blankPage"}>
            <div className="h-100 w-100" style={{ backgroundImage: `url(${backgroundPath}`, backgroundSize: "cover" }}></div>
            {displayParams.isFirstChampionship && displayParams.divisionNumber ? <div className={"eventName"}>
                <p className={"nameOnly"}><EventLogo logo={displayParams.eventLogo} /> {displayParams.eventName.replace(t` Division`, "")}</p>
                {displayParams.eventInverseSponsor ? <>
                    <p className={"sponsorIntro"}>{t`Sponsored By`}</p>
                    <img src={displayParams.eventInverseSponsor.logo} className={"sponsorLogo"} />
                </> : null}
            </div> : null}
            {timeout?.timer && config.type != 'cmpBar' ? <MiniTimeout type={displayParams.isFirstChampionship ? MiniTimeoutType.BOTTOM_RIGHT : MiniTimeoutType.BAR} config={config} timeout={timeout}/> : null }
        </div>
    </>;
}